var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#82AFFF"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M254.836,136.569l-6.801,20.392l-21.495,0.167c-1.178,0.009-1.667,1.513-0.719,2.213l17.292,12.769   l-6.484,20.495c-0.355,1.124,0.924,2.053,1.883,1.368l17.488-12.5l17.488,12.5c0.959,0.685,2.238-0.244,1.883-1.368l-6.484-20.495   l17.292-12.769c0.948-0.7,0.459-2.204-0.719-2.213l-21.495-0.167l-6.801-20.392C256.791,135.451,255.209,135.451,254.836,136.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M254.836,318.632l-6.801,20.392l-21.495,0.167c-1.178,0.009-1.667,1.513-0.719,2.213l17.292,12.769   l-6.484,20.495c-0.355,1.124,0.924,2.053,1.883,1.368l17.488-12.5l17.488,12.5c0.959,0.685,2.238-0.244,1.883-1.368l-6.484-20.495   l17.292-12.769c0.948-0.7,0.459-2.204-0.719-2.213l-21.495-0.167l-6.801-20.392C256.791,317.514,255.209,317.514,254.836,318.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M375.431,254.836l-20.392-6.801l-0.167-21.495c-0.009-1.178-1.513-1.667-2.213-0.719l-12.769,17.292   l-20.495-6.484c-1.124-0.355-2.053,0.924-1.368,1.883l12.5,17.488l-12.5,17.488c-0.685,0.959,0.244,2.238,1.368,1.883l20.495-6.484   l12.769,17.292c0.7,0.948,2.204,0.459,2.213-0.719l0.167-21.495l20.392-6.801C376.549,256.791,376.549,255.209,375.431,254.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M136.569,254.836l20.392-6.801l0.167-21.495c0.009-1.178,1.513-1.667,2.213-0.719l12.769,17.292   l20.495-6.484c1.124-0.355,2.053,0.924,1.368,1.883L181.473,256l12.5,17.488c0.685,0.959-0.244,2.238-1.368,1.883l-20.495-6.484   l-12.769,17.292c-0.7,0.948-2.204,0.459-2.213-0.719l-0.167-21.495l-20.392-6.801C135.451,256.791,135.451,255.209,136.569,254.836   z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFm);
export default __webpack_public_path__ + "static/media/fm.696342e8986cceb5b51f538b21a65287.svg";
export { ForwardRef as ReactComponent };